export default __webpack_public_path__ + "static/img_5-05adc0589e1523e4f44fd5079502ef7e.png";